var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDbFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.48906 0.0741698C2.61094 -0.02563 2.8 -0.0242629 2.92188 0.0755369C3.35313 0.429621 3.75781 0.811047 4.13594 1.22392C4.30781 1.02705 4.50313 0.812415 4.71406 0.637423C4.8375 0.536256 5.02813 0.536256 5.15156 0.63879C5.69219 1.08994 6.15 1.686 6.47188 2.25199C6.78906 2.80978 7 3.37987 7 3.7818C7 5.52624 5.44063 7 3.5 7C1.5375 7 0 5.52488 0 3.78043C0 3.25546 0.278125 2.61428 0.709375 1.97994C1.14531 1.33602 1.76094 0.664766 2.48906 0.0741698ZM3.52656 5.68756C3.92188 5.68756 4.27187 5.59187 4.60156 5.40047C5.25938 4.99854 5.43594 4.19467 5.04063 3.56306C4.97031 3.44002 4.79063 3.43182 4.68906 3.53572L4.29531 3.93628C4.19219 4.04018 4.00625 4.03745 3.90937 3.92945C3.65156 3.64235 3.19062 3.12968 2.92812 2.83849C2.82969 2.72912 2.64219 2.72775 2.54219 2.83712C2.01406 3.41815 1.74844 3.78453 1.74844 4.19604C1.75 5.13251 2.54063 5.68756 3.52656 5.68756Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbFire);
export default __webpack_public_path__ + "static/media/db-fire.e3eac50ce5aa4287fce9510f9566a133.svg";
export { ForwardRef as ReactComponent };